// import PropTypes from "prop-types";

import ChartkickChart from "../../../shared_components/chartkick_chart";

class CitiesBreakdownChart extends ChartkickChart {
}

CitiesBreakdownChart.propTypes = Object.assign({}, ChartkickChart.propTypes, {

});

export default CitiesBreakdownChart;
